__turbopack_context__.v({
  "carouselContainer": "GuidesCarousel-module-scss-module__M93HZG__carouselContainer",
  "carouselSubtitle": "GuidesCarousel-module-scss-module__M93HZG__carouselSubtitle",
  "carouselTitle": "GuidesCarousel-module-scss-module__M93HZG__carouselTitle",
  "header": "GuidesCarousel-module-scss-module__M93HZG__header",
  "item": "GuidesCarousel-module-scss-module__M93HZG__item",
  "loadingContainer": "GuidesCarousel-module-scss-module__M93HZG__loadingContainer",
  "loadingResponsiveWrapper": "GuidesCarousel-module-scss-module__M93HZG__loadingResponsiveWrapper",
  "root": "GuidesCarousel-module-scss-module__M93HZG__root",
});
